import { getCatalog, timeAgo, type Locale } from "../../i18n";
import type { PresentedEvent, PresentedNode, PresentedOrbital } from "../../presentation/mesh";
import { Metric, MetricGrid, RelationList, SignalList, StatusLine, type RelationItem } from "./InspectorPrimitives";

export function OrbitalInspectorBody({
  orbital,
  parent,
  siblings,
  events,
  locale,
  onOrbital,
}: {
  orbital: PresentedOrbital;
  parent: PresentedNode;
  siblings: PresentedOrbital[];
  events: PresentedEvent[];
  locale: Locale;
  onOrbital: (nodeId: string, orbitalId: string) => void;
}) {
  const ui = getCatalog(locale).ui;
  const items: RelationItem[] = siblings.map((item) => ({
    id: item.id,
    label: item.label,
    kind: item.kind,
    onSelect: () => onOrbital(parent.id, item.id),
  }));
  const metrics = (
    <MetricGrid>
      <Metric label={ui.parentSystem} value={parent.label} />
      <Metric label={ui.orbitalClass} value={orbital.eyebrow} />
      <Metric label={ui.lastSignal} value={timeAgo(orbital.metrics?.updatedAt, locale)} />
      <Metric label={ui.revision} value={orbital.metrics?.version ?? "—"} />
    </MetricGrid>
  );

  return (
    <>
      <StatusLine status={orbital.status} kind={orbital.kind} locale={locale} />
      <p className="inspector__description">{orbital.description}</p>

      <div className="inspector-desktop-detail-stack">
        {metrics}
        <section className="inspector-section">
          <div className="section-heading">
            <span>{ui.connectedEntities}</span>
            <b>{items.length.toString().padStart(2, "0")}</b>
          </div>
          <RelationList items={items} locale={locale} />
        </section>
        <section className="inspector-section inspector-section--events">
          <div className="section-heading">
            <span>{ui.recentSignals}</span>
            <b>{events.length.toString().padStart(2, "0")}</b>
          </div>
          <SignalList events={events} locale={locale} />
        </section>
      </div>
    </>
  );
}
